import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import AgentsDrawer from "components/drawer/AgentsDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ViewModal from "components/modal/ViewAgentsModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import Tooltip from "@mui/material/Tooltip";
import AgentDetailApprovalStatus from "components/modal/AgentDetailApproval";
import { SidebarContext } from "context/SidebarContext";
import useToggleDrawer from "hooks/useToggleDrawer";
import React, { useState, useContext, useEffect } from "react";
import EmailIcon from "@material-ui/icons/Email";
import { notifyError, notifySuccess } from "utils/toast";
import { FiEye } from "react-icons/fi";
import { FaCircle } from "react-icons/fa";

import DriverAproveReject from "components/modal/DriverAproveRejectModel";
import AgentsServices from "services/AgentsServices";
import ShowAgentStatus from "components/table/ShowAgentStatus";
import AgentRemarks from "components/modal/AgentRemarks";
import Switch from "@mui/material/Switch";
import { Select } from "antd";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

import AgentHistoryModal from "components/modal/AgentHistoryModel"; // adjus
import AgentAproveReject from "components/modal/AgentApproveorRejectModal";

const AgentsTable = ({
  agents,
  perpage,
  currentPage,
  tab,
  hideEdit,
  fetchAgents,
  isAdmin,
  allowAccess,
  hideView,
  hideDelete,
}) => {
  
  const { title, serviceId, handleModalOpen, handleView, handleUpdate } =
    useToggleDrawer();
  const { setIsUpdate } = useContext(SidebarContext);

  const [isRemarkModalOpen, setIsRemarkModalOpen] = useState(false);
  const [selectedTripadvance, setSelectedTripadvance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openRemarks, setOpenRemarks] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [toggleStates, setToggleStates] = useState({});
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [pendingToggle, setPendingToggle] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [keyManager, setKeyManager] = useState(null);
  //  console.log(showHistoryModal);

  // Function to fetch agent history details
  const fetchDetailHistory = async (agentId) => {
    try {
      const response = await AgentsServices.getAgentProfileHistory(agentId);
      if (response?.status) {
        return { success: true, data: response.data || [] };
      } else {
        return {
          success: false,
          message: response?.message || "No history found or error occurred.",
        };
      }
    } catch (error) {
      //console.error(" Error fetching agent history:", error);
      return {
        success: false,
        message: "Something went wrong while fetching history.",
      };
    }
  };

  // Call the function in your handler
  const handleViewHistory = async (data) => {
    setSelectedData(data);
    const result = await fetchDetailHistory(data.id);

    if (result.success) {
      setHistoryData(result.data);
      setShowHistoryModal(true);
    } else {
      alert(result.message);
    }
  };

  // Initialize toggle states based on agents data
  useEffect(() => {
    if (Array.isArray(agents)) {
      setToggleStates(
        agents.reduce(
          (acc, agent) => ({
            ...acc,
            [agent.id]: agent.agent_type === "online",
          }),
          {},
        ),
      );
    }
  }, [agents]);

  // Handle toggle switch change
  const handleToggleChange = (agentId, checked) => {
    if (checked) {
      setPendingToggle({ agentId, checked });
      setIsConfirmModalOpen(true);
    } else {
      updateAgentType(agentId, false);
    }
  };

  // Update agent type via API
  const updateAgentType = async (agentId, checked) => {
    try {
      setLoading(true);
      const body = { agent_type: checked ? "Online" : "Offline" };
      const response = await AgentsServices.agentType(agentId, body);
      if (response.status) {
        setToggleStates((prev) => ({ ...prev, [agentId]: checked }));
        setIsUpdate(true);
        notifySuccess(
          response.message ||
            `Agent moved to ${checked ? "Online" : "Offline"} successfully`,
        );
      } else {
        notifyError(response.message || "Failed to update agent type");
      }
    } catch (error) {
      //  console.error("Error updating agent type:", error);
      notifyError(
        error?.response?.data?.message || "Error updating agent type",
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle confirmation modal "Yes" click
  const handleConfirmYes = () => {
    if (pendingToggle) {
      updateAgentType(pendingToggle.agentId, pendingToggle.checked);
    }
    setIsConfirmModalOpen(false);
    setPendingToggle(null);
  };

  // Handle confirmation modal "No" click
  const handleConfirmNo = () => {
    setIsConfirmModalOpen(false);
    setPendingToggle(null);
  };

  // const handleModalAction = async (action, remark) => {
  const handleModalAction = async (action, actionData = {}) => {
    try {
      setLoading(true);
      const payload = {
        status: action === "approve" ? 1 : selectedTripadvance.newStatus,
        type: selectedTripadvance.agent_type,
        key_manager_id: Number(actionData.key_manager_id),
      };

      if (action === "reject") {
        payload.status = 2;
        // payload.reject_reason = remark || "Rejected";
        payload.reject_reason = actionData.remark || "Rejected";
      }

      const response = await AgentsServices.changeStatus(
        selectedTripadvance.id,
        payload,
      );
      setIsUpdate(true);
      if (response.status) {
        // setIsUpdate(true);
        notifySuccess(response.message);
      } else {
        notifyError(response);
      }
    } catch (error) {
      //  console.error("Error updating status:", error);
      notifyError(error?.response?.data?.message || "Error updating status");
    } finally {
      setLoading(false);
      setIsRemarkModalOpen(false);
    }
  };

  const handleApprove = (data) => {
    if (data.seller && data.transport_head) {
      setKeyManager(data.transport_head_id);
      setIsRemarkModalOpen(true);
      setSelectedTripadvance(data);
    } else {
      notifyError("Select Seller and Sales Manager");
    }
  };
  const handleApproveUpdate = async (data) => {
    try {
      setSelectedData(data);
      setModalOpen(true); // Optional – if you still want to open a modal
      const historyResult = await fetchDetailHistory(data.id);
      if (historyResult.success) {
        setHistoryData(historyResult.data);
      } else {
        notifyError(historyResult.message);
      }
    } catch (error) {
      //  console.error(" Error in handleApproveUpdate:", error);
      notifyError("Something went wrong while handling the approval update.");
    }
  };

  return (
    <>
      <AgentHistoryModal
        isOpen={showHistoryModal}
        onClose={() => setShowHistoryModal(false)}
        data={historyData}
        originalData={selectedData}
      />
      <AgentDetailApprovalStatus
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Approve or Reject Agent"
        message="Do you want to approve or reject the changes to agent details?"
        data={selectedData}
        historyData={historyData}
        fetchAgents={fetchAgents} // ← pass it
      />
      <AgentAproveReject
        isOpen={isRemarkModalOpen}
        onClose={() => setIsRemarkModalOpen(false)}
        title="Approve / Reject"
        newStatus={selectedTripadvance?.newStatus}
        onYesClick={(data) => handleModalAction("approve", data)}
        onRejectClick={(data) => handleModalAction("reject", data)}
        loading={loading}
        keyManager={keyManager}
      />
      <AgentRemarks
        isOpen={openRemarks}
        selectedData={selectedData}
        onClose={() => setOpenRemarks(false)}
      />
      <DeleteModal id={serviceId} title={title} />
      <ViewModal id={serviceId} title={title} data={agents} />
      <MainDrawer>
        <AgentsDrawer id={serviceId} tab={tab} />
      </MainDrawer>
      <Dialog
        open={isConfirmModalOpen}
        onClose={handleConfirmNo}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
      >
        <DialogTitle id="confirm-dialog-title">Confirm Action</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            Are you sure you want to move this agent to online?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmNo} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmYes} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <TableBody>
        {Array.isArray(agents) && agents.length > 0 ? (
          agents.slice(0, perpage).map((data, index) => (

            <TableRow key={data.id || index}>
              <TableCell className="font-semibold text-xs text-center">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.reference_no || "N/A"}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.added_date
                  ? new Date(data.added_date).toLocaleDateString("en-GB")
                  : "N/A"}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.company_name || "N/A"}
              </TableCell>
              <TableCell className="text-sm text-center">
                {data.name || "N/A"}
              </TableCell>

              {/* <TableCell className="text-sm text-center">
                {data.agent_type === "Offline" ? (
                  <Select
                    value={data.agent_type}
                    disabled={!isAdmin || data.agent_type === "Online"}
                    onChange={(value) => handleToggleChange(data.id, value)}
                    loading={loading}
                    style={{ width: 100 }}
                    options={[
                      {
                        value: "Online",
                        label: <span className="text-green-500">Online</span>,
                      },
                      {
                        value: "Offline",
                        label: <span className="text-red-500">Offline</span>,
                      },
                    ]}
                  />
                ) : (
                  <span className="text-green-500">Online</span>
                )}
              </TableCell> */}

              <TableCell className={`text-sm text-center ${data.agent_type === "Online" ? "text-green-500" : data.agent_type === "Offline" ? "text-red-500" : "text-gray-500"}`}>
                {data.agent_type || "-"}
              </TableCell>

              {/* {console.log(data)} */}
              {/* <TableCell className="text-sm text-center">
                <Tooltip title={data.email_id || "No Email"}>
                  <EmailIcon style={{ color: data.email_id ? "grey" : "#d3d3d3" }} />
                </Tooltip>
              </TableCell> */}
              {tab === 0 && (
                <TableCell className="text-sm text-center">
                  {data.account_info || "N/A"}
                </TableCell>
              )}
              {tab === 1 ? (
                <TableCell className="text-center text-xs">
                  <div className="mt-1">
                    <div
                      className={`${
                        data.is_active === 1
                          ? "text-green-600 font-semibold"
                          : data.is_active === 2
                            ? "text-red-600 font-semibold"
                            : "text-gray-500 font-semibold"
                      }`}
                    >
                      {data.is_active === 0
                        ? "Inactive"
                        : data.is_active === 1
                          ? "Active"
                          : data.is_active === 2
                            ? "Blocked"
                            : "Unknown"}
                    </div>
                    {isAdmin && (
                      <ShowAgentStatus id={data.id} status={data.is_active} />
                    )}
                  </div>
                </TableCell>
              ) : tab === 0 && hideEdit ? (
                data.approval_status === 0 ? (
                  <TableCell className="text-center">
                    <span
                      style={{ cursor: "pointer", color: "green" }}
                      onClick={() => handleApproveUpdate(data)}
                    >
                      <span style={{ color: "green" }}>Verify</span> /{" "}
                      <span style={{ color: "red" }}>Reject</span>
                    </span>
                  </TableCell>
                ) : (
                  <TableCell className="text-center">
                    <span
                      style={{ cursor: "pointer", color: "green" }}
                      onClick={() => handleApprove(data)}
                      // onClick={() => {
                      //   setKeyManager(data.transport_head_id);
                      //   handleApprove(data);
                      // }}
                    >
                      <span style={{ color: "green" }}>Verify</span> /{" "}
                      <span style={{ color: "red" }}>Reject</span>
                    </span>
                  </TableCell>
                )
              ) : null}

              {tab === 1 && (
                <TableCell className="text-center">
                  <div className="flex justify-center items-center h-full">
                    {data.login_status === 1 ? (
                      <span className="text-green-500">
                        <FaCircle />
                      </span>
                    ) : (
                      <span className="text-red-500">
                        <FaCircle />
                      </span>
                    )}
                  </div>
                </TableCell>
              )}

              {hideView && tab === 1 && (
                <TableCell className="text-center">
                  <span
                    className="text-sm cursor-pointer"
                    onClick={() => {
                      setSelectedData(data);
                      setOpenRemarks(true);
                    }}
                  >
                    view
                  </span>
                </TableCell>
              )}
              {tab === 0 && data.approval_status === 0 ? (
                <TableCell className="text-center">
                  <span
                    className="cursor-pointer text-blue-600"
                    onClick={() => handleViewHistory(data)}
                  >
                    Check
                  </span>
                </TableCell>
              ) : (
                <TableCell>
                  <div className="flex justify-center">
                    <div className="p-2 cursor-pointer text-gray-400 hover:text-green-600">
                      <button
                        onClick={() => handleView(data.id, "Agents Details")}
                        className="p-2 cursor-pointer text-gray-400 hover:text-red-600 focus:outline-none"
                        aria-label={`View details for ${data.name}`}
                      >
                        <FiEye />
                      </button>
                    </div>

                    <EditDeleteButton
                      title={"Agents"}
                      id={data.id}
                      handleUpdate={handleUpdate}
                      handleModalOpen={handleModalOpen}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={tab === 0 ? 8 : 9} className="text-center">
              No agents found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  );
};

export default AgentsTable;
